/**
 * 视频时长就近匹配工具
 * 当用户切换视频模型时，将当前 duration 匹配到新模型支持的最接近值
 * 
 * 前后端共享的唯一实现，前后端各自的 snap-duration.ts 应 re-export 此函数
 */

/**
 * 将 duration 就近匹配到模型支持的时长
 * @param duration 当前时长（秒）
 * @param supportedDurations 模型支持的时长列表（无需预排序）
 * @returns 最接近的合法时长，距离相同时取较小值
 * @throws 当 supportedDurations 为空时抛出错误
 */
export function snapDuration(duration: number, supportedDurations: number[]): number {
  if (supportedDurations.length === 0) {
    throw new Error('supportedDurations 不能为空');
  }

  // 已在支持列表中，直接返回
  if (supportedDurations.includes(duration)) return duration;

  // 找到距离最近的值，距离相同取较小值
  return supportedDurations.reduce((closest, d) => {
    const diffNew = Math.abs(d - duration);
    const diffOld = Math.abs(closest - duration);
    if (diffNew < diffOld) return d;
    if (diffNew === diffOld) return Math.min(d, closest);
    return closest;
  });
}
